import React from "react";

import HeroImage from "../../../src/assets/img/new-layout/ana-lucena-AL.png";
import { APP_STRINGS } from "constants/appStrings";

import * as Styles from "./styles";

const SliderComponent = ({ onPrimaryAction }) => {
  return (
    <Styles.Container>
      <Styles.BackdropImage image={HeroImage} />
      <Styles.Glow className="top" />
      <Styles.Glow className="bottom" />

      <Styles.Inner>
        <Styles.HeroContent>
          <Styles.Eyebrow>{APP_STRINGS.hero.eyebrow}</Styles.Eyebrow>
          <Styles.Title>{APP_STRINGS.hero.title}</Styles.Title>
          <Styles.Subtitle>{APP_STRINGS.hero.subtitle}</Styles.Subtitle>

          <Styles.Actions>
            <Styles.PrimaryButton type="button" onClick={onPrimaryAction}>
              {APP_STRINGS.hero.primaryCta}
            </Styles.PrimaryButton>
            <Styles.SecondaryButton
              href={APP_STRINGS.links.whatsapp}
              target="_blank"
              rel="noreferrer"
            >
              {APP_STRINGS.hero.secondaryCta}
            </Styles.SecondaryButton>
          </Styles.Actions>

          <Styles.Metrics>
            {APP_STRINGS.hero.metrics.map((metric) => (
              <Styles.MetricCard key={metric.value}>
                <Styles.MetricValue>{metric.value}</Styles.MetricValue>
                <Styles.MetricLabel>{metric.label}</Styles.MetricLabel>
              </Styles.MetricCard>
            ))}
          </Styles.Metrics>
        </Styles.HeroContent>

        <Styles.SidePanel>
          <Styles.PanelTag>{APP_STRINGS.hero.panelTag}</Styles.PanelTag>
          <Styles.PanelTitle>{APP_STRINGS.hero.panelTitle}</Styles.PanelTitle>

          <Styles.PanelList>
            {APP_STRINGS.hero.panelItems.map((item) => (
              <Styles.PanelItem key={item.title}>
                <Styles.PanelItemTitle>{item.title}</Styles.PanelItemTitle>
                <Styles.PanelItemText>{item.text}</Styles.PanelItemText>
              </Styles.PanelItem>
            ))}
          </Styles.PanelList>
        </Styles.SidePanel>
      </Styles.Inner>
    </Styles.Container>
  );
};

export default SliderComponent;
